import * as React from 'react';
import { createTRPCOptionsProxy } from './createOptionsProxy.mjs';

/**
 * Create a set of type-safe provider-consumers
 *
 * @see https://trpc.io/docs/client/tanstack-react-query/setup#3a-setup-the-trpc-context-provider
 */ function createTRPCContext() {
    const TRPCClientContext = /*#__PURE__*/ React.createContext(null);
    const TRPCContext = /*#__PURE__*/ React.createContext(null);
    function TRPCProvider(props) {
        const value = React.useMemo(()=>createTRPCOptionsProxy({
                client: props.trpcClient,
                queryClient: props.queryClient
            }), [
            props.trpcClient,
            props.queryClient
        ]);
        return /*#__PURE__*/ React.createElement(TRPCClientContext.Provider, {
            value: props.trpcClient
        }, /*#__PURE__*/ React.createElement(TRPCContext.Provider, {
            value: value
        }, props.children));
    }
    function useTRPC() {
        const utils = React.useContext(TRPCContext);
        if (!utils) {
            throw new Error('useTRPC() can only be used inside of a <TRPCProvider>');
        }
        return utils;
    }
    function useTRPCClient() {
        const client = React.useContext(TRPCClientContext);
        if (!client) {
            throw new Error('useTRPCClient() can only be used inside of a <TRPCProvider>');
        }
        return client;
    }
    return {
        TRPCProvider,
        useTRPC,
        useTRPCClient
    };
}

export { createTRPCContext };
